import React, { Component } from 'react';
import css from './ErrorBoundary.scss';

type State = {
	error: null | typeof Error;
	info: null | React.ErrorInfo;
};

type Props = {
	content?: () => React.ReactNode;
};

class ErrorBoundary extends Component<Props, State> {
	state: State = { error: null, info: null };

	componentDidCatch(error, info: React.ErrorInfo) {
		this.setState({ error, info });
	}

	render() {
		const { error, info } = this.state;

		if (error) {
			return (
				<div className={css.root}>
					<div className={css.hero}>
						<h2 className={css.title}>
							Something went wrong...
							<span role="img" aria-labelledby="error">
								🙊🙈🙉
							</span>
						</h2>
						<button
							className={css.btn}
							type="button"
							onClick={() => window.location.reload()}
							data-text="reload page"
						>
							reload page
						</button>
					</div>

					<br />

					<details style={{ whiteSpace: 'pre-wrap', outline: 'none', cursor: 'pointer' }}>
						<summary style={{ outline: 'none' }}>Details</summary>
						{error.toString()}
						<br />
						{info && info.componentStack}
					</details>

					<br />

					{this.props.content && this.props.content()}
				</div>
			);
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
